import _ from "underscore";
import { ApiGroup } from "avvir";

import addReadOnlyPropertiesToModel from "../../services/utilities/mixins/add_read_only_properties_to_model";
import addDateGetterAndSetterToDomainModel from "../../services/utilities/mixins/add_date_getter_and_setter_to_domain_model";

import type { ModifyPartial } from "type_aliases";

function isMemberIdArray(members: any[]): members is number[] {
  return members?.length && typeof members[0] === "number";
}

type GroupArgument = ModifyPartial<ApiGroup, {
  members: ApiGroup["members"] | number[]
}>

export default class Group {
  constructor(apiGroup: GroupArgument) {
    addReadOnlyPropertiesToModel(this, {
      id: apiGroup.id,
      floorId: apiGroup.floorId
    });
    addDateGetterAndSetterToDomainModel(this, "createdAt", apiGroup.createdAt);

    this.name = apiGroup.name;
    this.createdBy = apiGroup.createdBy;
    if (isMemberIdArray(apiGroup.members)) {
      this.members = apiGroup.members;
    } else {
      this.members = _.pluck(apiGroup.members, "id");
    }
  }

  readonly id: number;
  name: string;
  createdAt: Date;
  createdBy: number;
  members: number[];
  readonly floorId: string;
}
